<prism-dialog id="sh-confirm-dialog-container-div" [visible]="true">
	<div id="sh-confirm-title-div" slot="dialog-title">{{ dialogData.title }}</div>
	<div id="sh-confirm-content-div">
		{{ dialogData.body }}
	</div>
	<div id="sh-confirm-action-buttons-div" slot="dialog-footer-buttons">
		@if (dialogData.cancelLabel) {
			<prism-button variant="text" (click)="closeDialog()" id="sh-confirm-button-cancel">
				{{ dialogData.cancelLabel }}
			</prism-button>
		}
		<prism-button
			variant="{{ dialogData.confirmVariant || 'primary' }}"
			(click)="confirmAction()"
			id="sh-confirm-confirm-button"
		>
			{{ dialogData.confirmLabel }}
		</prism-button>
	</div>
</prism-dialog>
